import moment from 'moment';

export default {
  methods: {
    getFriendlyDate(input) {
      const formatDate = (date) => {
        const mDate = moment(date);
        const today = moment();
        const tomorrow = moment().add(1, 'day');
        const yesterday = moment().subtract(1, 'day');

        if (mDate.isSame(today, 'day')) {
          return 'сьогодні';
        } else if (mDate.isSame(tomorrow, 'day')) {
          return 'завтра';
        } else if (mDate.isSame(yesterday, 'day')) {
          return 'вчора';
        } else {
          return mDate.format('D MMMM');
        }
      };

      const isNamedDay = (date) => {
        const d = formatDate(date);
        return ['сьогодні', 'завтра', 'вчора'].includes(d);
      };

      if (Array.isArray(input) && input.length === 2) {
        const [startRaw, endRaw] = input;
        const start = moment(startRaw);
        const end = moment(endRaw);

        if (start.isSame(end, 'day')) {
          return formatDate(start);
        }

        const startNamed = formatDate(startRaw);
        const endNamed = formatDate(endRaw);

        if (isNamedDay(startRaw) || isNamedDay(endRaw)) {
          return `${startNamed} – ${endNamed}`;
        }

        if (start.isSame(end, 'month') && start.isSame(end, 'year')) {
          return `${start.format('D')}–${end.format('D')} ${end.format('MMMM')}`;
        }

        return `${start.format('D MMMM')} – ${end.format('D MMMM')}`;
      }

      return formatDate(input);
    }
  },
};
